import type { RouteObject } from "react-router-dom";
import NotFound from "../pages/NotFound";
import Home from "../pages/home/page";
import SpreadsheetGuide from "../pages/articles/allchinabuy-spreadsheet-guide/page";
import BestShoes from "../pages/articles/allchinabuy-best-shoes-spreadsheet-2026/page";
import TrustedSellers from "../pages/articles/allchinabuy-trusted-sellers-list/page";
import ClothingGuide from "../pages/articles/allchinabuy-clothing-spreadsheet-guide/page";
import QCGuide from "../pages/articles/allchinabuy-qc-photos-guide/page";
import YupooGuide from "../pages/articles/allchinabuy-yupoo-spreadsheet-guide/page";
import BagsGuide from "../pages/articles/allchinabuy-bags-spreadsheet-guide/page";
import ShippingTips from "../pages/articles/allchinabuy-shipping-tips-guide/page";
import FreeFinds from "../pages/articles/free-allchinabuy-finds-daily/page";
import Comparison from "../pages/articles/allchinabuy-spreadsheet-vs-alternatives/page";

const routes: RouteObject[] = [
  {
    path: "/",
    element: <Home />,
  },
  {
    path: "/allchinabuy-spreadsheet-guide",
    element: <SpreadsheetGuide />,
  },
  {
    path: "/allchinabuy-best-shoes-spreadsheet-2026",
    element: <BestShoes />,
  },
  {
    path: "/allchinabuy-trusted-sellers-list",
    element: <TrustedSellers />,
  },
  {
    path: "/allchinabuy-clothing-spreadsheet-guide",
    element: <ClothingGuide />,
  },
  {
    path: "/allchinabuy-qc-photos-guide",
    element: <QCGuide />,
  },
  {
    path: "/allchinabuy-yupoo-spreadsheet-guide",
    element: <YupooGuide />,
  },
  {
    path: "/allchinabuy-bags-spreadsheet-guide",
    element: <BagsGuide />,
  },
  {
    path: "/allchinabuy-shipping-tips-guide",
    element: <ShippingTips />,
  },
  {
    path: "/free-allchinabuy-finds-daily",
    element: <FreeFinds />,
  },
  {
    path: "/allchinabuy-spreadsheet-vs-alternatives",
    element: <Comparison />,
  },
  {
    path: "*",
    element: <NotFound />,
  },
];

export default routes;